import React from 'react';

import { css } from '@emotion/react';
import { NeutralColorToken, TextButton, Type } from '@robinhood/design';

const UserCreationDisclosure = () => {
  return (
    <div css={disclosure}>
      <Type.Text size='S' color={NeutralColorToken.Fg3}>
        {'By continuing, you are agreeing to Robinhood’s '}
        <TextButton
          label='Terms of Use'
          color={NeutralColorToken.Fg3}
          variant='inline'
          type='anchor'
          href='https://api.robinhood.com/creditcard/legal/terms#:~:text=Robinhood%20Credit%20Card%20Mobile%20Application%20Terms%20of%20Use'
          target='_blank'
          rel='noopener noreferrer'
        />
        {', '}
        <TextButton
          label='Electronic Communications Consent'
          color={NeutralColorToken.Fg3}
          variant='inline'
          type='anchor'
          href='https://api.robinhood.com/creditcard/legal/electronic-disclosures/'
          target='_blank'
          rel='noopener noreferrer'
        />
        {', and '}
        <TextButton
          label='Privacy Policy'
          color={NeutralColorToken.Fg3}
          variant='inline'
          type='anchor'
          href='https://robinhood.com/us/en/support/articles/privacy-policy/'
          target='_blank'
          rel='noopener noreferrer'
        />
        {'. This site is protected by reCAPTCHA and the Google '}
        <TextButton
          label='Privacy Policy'
          color={NeutralColorToken.Fg3}
          variant='inline'
          type='anchor'
          href='https://policies.google.com/privacy'
          target='_blank'
          rel='noopener noreferrer'
        />
        {' and '}
        <TextButton
          label='Terms of Service'
          color={NeutralColorToken.Fg3}
          variant='inline'
          type='anchor'
          href='https://policies.google.com/terms'
          target='_blank'
          rel='noopener noreferrer'
        />
        {' apply.'}
      </Type.Text>
    </div>
  );
};

const disclosure = css`
  text-align: center;
`;

export default UserCreationDisclosure;
